(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-cart"]) return;
  try {
    
  (function () {
    var DEBOUNCE = 300;
    var timer = null;

    function root() {
      return document.querySelector('[data-sp-cart]');
    }

    function lineRow(line) {
      return document.querySelector('[data-sp-line="' + line + '"]');
    }

    function fallbackError() {
      return (window.cartStrings && window.cartStrings.error) || '';
    }

    function showError(line, message, input) {
      var row = line ? lineRow(line) : null;
      var slot = row ? row.querySelector('[data-sp-error]') : null;
      if (!slot) slot = document.querySelector('[data-sp-cart-error]');
      if (slot) {
        slot.textContent = message;
        if (slot.parentElement) slot.parentElement.classList.add('is-on');
      }
      // Repoe o valor que o servidor confirmou, para o ecra nao mentir.
      if (input) input.value = input.defaultValue;
    }

    function clearErrors() {
      document.querySelectorAll('[data-sp-error], [data-sp-cart-error]').forEach(function (slot) {
        slot.textContent = '';
        if (slot.parentElement) slot.parentElement.classList.remove('is-on');
      });
    }

    function repaint(el, state) {
      var html = state.sections && state.sections[el.dataset.spSection];
      if (!html) {
        window.location.reload();
        return;
      }
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sp-cart]');
      if (!fresh) {
        window.location.reload();
        return;
      }

      // A nota do cliente so viaja no submit do formulario; sem isto, uma mudanca de
      // quantidade repunha o valor do servidor e apagava o que estava a ser escrito.
      var note = el.querySelector('[data-sp-note]');
      var pending = note ? note.value : null;

      el.innerHTML = fresh.innerHTML;

      if (pending !== null) {
        var freshNote = el.querySelector('[data-sp-note]');
        if (freshNote) freshNote.value = pending;
      }

      var bubble = document.querySelector('.cart-count');
      if (bubble) bubble.textContent = state.item_count;

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sp-cart', cartData: state });
      }
    }

    function change(line, quantity, input) {
      var el = root();
      if (!el) return;

      clearErrors();
      el.classList.add('is-busy');

      fetch(el.dataset.spChangeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity,
          sections: [el.dataset.spSection],
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (state) {
          if (!state || state.status || state.errors) {
            showError(line, (state && (state.description || state.message || state.errors)) || fallbackError(), input);
            return;
          }
          repaint(el, state);
        })
        .catch(function () {
          showError(line, fallbackError(), input);
        })
        .finally(function () {
          var current = root();
          if (current) current.classList.remove('is-busy');
        });
    }

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.matches || !input.matches('[data-sp-qty]')) return;
      var row = input.closest('[data-sp-line]');
      if (!row) return;

      var quantity = parseInt(input.value, 10);
      if (isNaN(quantity) || quantity < 0) {
        input.value = input.defaultValue;
        return;
      }

      var line = row.dataset.spLine;
      clearTimeout(timer);
      timer = setTimeout(function () {
        change(line, quantity, input);
      }, DEBOUNCE);
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      var remove = event.target.closest('[data-sp-remove]');
      if (!remove) return;
      event.preventDefault();
      change(remove.dataset.spRemove, 0, null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-collection"]) return;
  try {
    
  (function () {
    var narrow = window.matchMedia('(max-width: 1080px)');

    function syncPanels() {
      document.querySelectorAll('.sp-fpanel').forEach(function (panel) {
        // ⚠ O "mexido a mao" so vale em ecra estreito. No desktop o toggle esta
        // display:none, logo um painel fechado ficaria inalcancavel agora que o
        // .sp-fpanel__body deixou de ser display:block incondicional.
        if (narrow.matches && panel.dataset.spTouched === 'true') return;
        if (narrow.matches) {
          panel.removeAttribute('open');
        } else {
          panel.setAttribute('open', '');
        }
      });
    }

    document.querySelectorAll('.sp-fpanel').forEach(function (panel) {
      panel.addEventListener('toggle', function () {
        // Uma vez mexido a mao, o JS deixa de decidir por ele.
        if (narrow.matches) panel.dataset.spTouched = 'true';
      });
    });

    syncPanels();
    if (narrow.addEventListener) narrow.addEventListener('change', syncPanels);

    // Ordenacao: submete na mudanca e esconde o botao "Apply" (que so existe para quem nao tem JS).
    document.querySelectorAll('.sp-sort').forEach(function (form) {
      var button = form.querySelector('[data-sp-autohide]');
      var select = form.querySelector('select');
      // ⚠ `button.hidden = true` NAO chega: a classe `.btn` do sp-base.css poe
      // `display:inline-flex`, que ganha a `[hidden]{display:none}` — o botao fica
      // com hidden=true E display=flex ao mesmo tempo, visivel ao lado do selector.
      // Medido no sp-search antes de o mesmo bug ser encontrado aqui. Remover e a saida segura.
      if (button) button.remove();
      if (select) {
        select.addEventListener('change', function () {
          form.submit();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-hero"] && !Shopify.designMode) return;
  try {
    
  // Quem pediu menos movimento no sistema fica com o poster: o video nao arranca sozinho.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('[data-sp-strip-video]').forEach(function (v) {
      v.removeAttribute('autoplay');
      v.pause();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-product"]) return;
  try {
    
(function () {
  function activate(gallery, index) {
    gallery.querySelectorAll('[data-sp-slide]').forEach(function (slide) {
      slide.toggleAttribute('hidden', slide.dataset.spSlide !== index);
    });
    gallery.querySelectorAll('[data-sp-thumb]').forEach(function (thumb) {
      thumb.setAttribute('aria-pressed', thumb.dataset.spThumb === index ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest && event.target.closest('[data-sp-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-sp-gallery]');
    if (!gallery) return;
    activate(gallery, thumb.dataset.spThumb);
  });

  // Variante com media propria -> mostra essa imagem. O Dawn nao o faz por nos:
  // updateMedia() em product-info.js depende de <media-gallery>, que esta pagina nao usa.
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      var mediaId = variant && variant.featured_media && variant.featured_media.id;
      if (!mediaId) return;
      document.querySelectorAll('[data-sp-gallery]').forEach(function (gallery) {
        var slide = gallery.querySelector('[data-sp-media-id="' + mediaId + '"][data-sp-slide]');
        if (slide) activate(gallery, slide.dataset.spSlide);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sp-rep-carousel')) {
    customElements.define('sp-rep-carousel', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.track = this.querySelector('[data-rep-track]');
        this.slides = [].slice.call(this.querySelectorAll('[data-rep-slide]'));
        this.dots = [].slice.call(this.querySelectorAll('[data-rep-dot]'));
        this.nav = this.querySelector('[data-rep-nav]');
        this.index = 0;
        this.max = 0;
        if (!this.track || this.slides.length < 2) return;

        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var prev = this.querySelector('[data-rep-prev]');
        var next = this.querySelector('[data-rep-next]');
        this.toggle = this.querySelector('[data-rep-toggle]');
        this.stopped = false;
        if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); self.restart(); });
        if (next) next.addEventListener('click', function () { self.go(self.index + 1); self.restart(); });
        this.dots.forEach(function (d) {
          d.addEventListener('click', function () { self.go(parseInt(d.getAttribute('data-rep-dot'), 10)); self.restart(); });
        });

        // O indice segue o scroll real: setas, pontos, dedo, teclado ou trackpad.
        var settle;
        this.track.addEventListener('scroll', function () {
          clearTimeout(settle);
          settle = setTimeout(function () { self.sync(); }, 120);
        }, { passive: true });
        this.onResize = function () { self.measure(); self.restart(); };
        window.addEventListener('resize', this.onResize);

        // Os cards fora do ecra estao cortados pela faixa e o reveal do sp-motion.js nunca os
        // veria entrar: quando a faixa aparece, entram todos de uma vez.
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (es) {
            if (!es[0].isIntersecting) return;
            self.slides.forEach(function (s) { s.classList.add('in'); });
            self.io.disconnect();
          }, { threshold: 0.12 });
          this.io.observe(this.track);
        }

        // Autoplay: desligado com prefers-reduced-motion; parado com o rato por cima, com o
        // foco dentro, com o dedo na faixa e com o separador escondido.
        this.autoplay = this.getAttribute('data-autoplay') === 'true' && !this.reduce;
        this.interval = parseInt(this.getAttribute('data-interval'), 10) || 6000;
        this.hover = false; this.focus = false; this.touch = false;
        // Pausa pelo botao: fica parado ate novo clique (o rato a sair ou o foco a sair nao retomam).
        if (this.toggle && this.autoplay) {
          this.toggle.hidden = false;
          this.toggle.addEventListener('click', function () { self.setStopped(!self.stopped); });
        }
        this.setStopped(false);
        this.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') self.hover = true; });
        this.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') self.hover = false; });
        this.addEventListener('focusin', function () { self.focus = true; });
        this.addEventListener('focusout', function (e) { if (!self.contains(e.relatedTarget)) self.focus = false; });
        this.track.addEventListener('touchstart', function () { self.touch = true; }, { passive: true });
        this.track.addEventListener('touchend', function () { self.touch = false; self.restart(); }, { passive: true });

        this.measure();
        this.restart();
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        if (this.onResize) window.removeEventListener('resize', this.onResize);
        if (this.io) this.io.disconnect();
      }
      measure() {
        var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        var step = this.slides[0].getBoundingClientRect().width + gap;
        var visible = step > 0 ? Math.max(1, Math.round((this.track.clientWidth + gap) / step)) : 1;
        this.max = Math.max(0, this.slides.length - visible);
        var max = this.max;
        this.dots.forEach(function (d, k) { d.hidden = k > max; });
        if (this.nav) this.nav.hidden = max === 0;
        this.sync();
      }
      sync() {
        var track = this.track, left = track.scrollLeft, best = 0, dist = Infinity;
        if (left >= track.scrollWidth - track.clientWidth - 2) {
          best = this.max;
        } else {
          this.slides.forEach(function (s, k) {
            var d = Math.abs(s.offsetLeft - left);
            if (d < dist) { dist = d; best = k; }
          });
        }
        this.mark(Math.min(best, this.max));
      }
      mark(i) {
        this.index = i;
        this.dots.forEach(function (d, k) {
          d.classList.toggle('is-active', k === i);
          if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
      }
      setStopped(on) {
        this.stopped = on;
        var t = this.toggle;
        if (t) {
          t.classList.toggle('is-stopped', on);
          t.setAttribute('aria-label', t.getAttribute(on ? 'data-label-play' : 'data-label-pause'));
        }
        // Enquanto roda, o leitor de ecra nao anuncia cada troca; parado, anuncia a navegacao.
        this.track.setAttribute('aria-live', this.autoplay && !on ? 'off' : 'polite');
        this.restart();
      }
      restart() {
        var self = this;
        clearInterval(this.timer);
        if (!this.autoplay || this.stopped || this.max === 0) return;
        this.timer = setInterval(function () {
          if (!self.stopped && !self.hover && !self.focus && !self.touch && !document.hidden) self.go(self.index + 1);
        }, this.interval);
      }
      go(i) {
        var n = this.max + 1;
        i = ((i % n) + n) % n;
        this.track.scrollTo({ left: this.slides[i].offsetLeft, behavior: this.reduce ? 'auto' : 'smooth' });
        this.mark(i);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-search"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var narrow = window.matchMedia('(max-width: 1080px)');

    function syncPanels() {
      document.querySelectorAll('.sps-fpanel').forEach(function (panel) {
        // ⚠ O "mexido a mao" so vale em ecra estreito. No desktop o toggle esta
        // display:none, logo um painel fechado ficaria inalcancavel agora que o
        // .sps-fpanel__body deixou de ser display:block incondicional.
        if (narrow.matches && panel.dataset.spsTouched === 'true') return;
        if (narrow.matches) {
          panel.removeAttribute('open');
        } else {
          panel.setAttribute('open', '');
        }
      });
    }

    document.querySelectorAll('.sps-fpanel').forEach(function (panel) {
      panel.addEventListener('toggle', function () {
        // Uma vez mexido a mao, o JS deixa de decidir por ele.
        if (narrow.matches) panel.dataset.spsTouched = 'true';
      });
    });

    syncPanels();
    if (narrow.addEventListener) narrow.addEventListener('change', syncPanels);

    // Ordenacao: submete na mudanca e retira o botao "Apply" (que so existe para quem nao tem JS).
    // ⚠ `button.hidden = true` NAO chega: a classe `.btn` do sp-base.css poe
    //    `display:inline-flex`, que ganha ao `[hidden]{display:none}` da folha do agente —
    //    o atributo fica la e o botao continua visivel. Medido: hidden=true, display=flex.
    //    Remover do DOM e imune a especificidade.
    document.querySelectorAll('.sps-sort').forEach(function (form) {
      var button = form.querySelector('[data-sps-autohide]');
      var select = form.querySelector('select');
      if (button) button.remove();
      if (select) {
        select.addEventListener('change', function () {
          form.submit();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-spotlight"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sp-slider')) {
    customElements.define('sp-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = [].slice.call(this.querySelectorAll('[data-sp-slide]'));
        this.dots = [].slice.call(this.querySelectorAll('[data-sp-dot]'));
        this.numeral = this.querySelector('[data-sp-numeral]');
        var band = this.closest('.spotlight');
        this.bgs = band ? [].slice.call(band.querySelectorAll('[data-sp-bg]')) : [];
        this.index = 0;
        if (this.slides.length < 2) return;

        var self = this;
        var prev = this.querySelector('[data-sp-prev]');
        var next = this.querySelector('[data-sp-next]');
        if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); self.restart(); });
        if (next) next.addEventListener('click', function () { self.go(self.index + 1); self.restart(); });
        this.dots.forEach(function (d) {
          d.addEventListener('click', function () { self.go(parseInt(d.getAttribute('data-sp-dot'), 10)); self.restart(); });
        });

        // Deslizar com o dedo (so horizontal, a partir de 40px).
        var x0 = null, y0 = null;
        this.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
        this.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { self.go(self.index + (dx < 0 ? 1 : -1)); self.restart(); }
          x0 = null;
        });

        // Autoplay: desligado com prefers-reduced-motion, parado com o rato ou o foco dentro.
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.getAttribute('data-autoplay') === 'true' && !reduce;
        this.interval = parseInt(this.getAttribute('data-interval'), 10) || 6000;
        this.paused = false;
        this.addEventListener('mouseenter', function () { self.paused = true; });
        this.addEventListener('mouseleave', function () { self.paused = false; });
        this.addEventListener('focusin', function () { self.paused = true; });
        this.addEventListener('focusout', function () { self.paused = false; });
        this.restart();
      }
      disconnectedCallback() { clearInterval(this.timer); }
      restart() {
        var self = this;
        clearInterval(this.timer);
        if (!this.autoplay) return;
        this.timer = setInterval(function () {
          if (!self.paused && !document.hidden) self.go(self.index + 1);
        }, this.interval);
      }
      go(i) {
        var n = this.slides.length;
        i = (i + n) % n;
        this.slides.forEach(function (s, k) {
          var on = k === i;
          s.classList.toggle('is-active', on);
          if (on) { s.removeAttribute('aria-hidden'); s.removeAttribute('inert'); }
          else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('inert', ''); }
        });
        this.bgs.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
        this.dots.forEach(function (d, k) {
          d.classList.toggle('is-active', k === i);
          if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
        if (this.numeral) this.numeral.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
        this.index = i;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
